import React, { useState, useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModificaEvento from './ModificaEvento';
import api from './services/api';

const EventList = ({ idAzienda }) => {
  const [eventi, setEventi] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedEvento, setSelectedEvento] = useState(null);
  const [selectedAziendaId, setSelectedAziendaId] = useState(idAzienda || null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (idAzienda || selectedAziendaId) return;

    const controller = new AbortController();
    (async () => {
      try {
        const response = await api.getMyAziende();
        if (controller.signal.aborted) return;
        const data = response.data;
        if (Array.isArray(data) && data.length > 0) {
          setSelectedAziendaId(data[0].idAzienda);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          toast.error('Errore durante il recupero delle aziende');
        }
      }
    })();

    return () => controller.abort();
  }, [idAzienda, selectedAziendaId]);

  useEffect(() => {
    if (!selectedAziendaId) return;

    const controller = new AbortController();
    setLoading(true);

    (async () => {
      try {
        const response = await api.listEventi(
          selectedAziendaId,
          currentPage,
          10,
          'idEvento,desc',
          controller.signal
        );
        if (controller.signal.aborted) return;
        setEventi(response.data.eventi);
        setPageCount(response.data.paginaEventi);
      } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') return;
        toast.error('Errore durante il recupero degli eventi');
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    })();

    return () => controller.abort();
  }, [selectedAziendaId, currentPage]);

  const handlePageClick = (data) => setCurrentPage(data.selected);

  const handleSelectEvento = (evento) => setSelectedEvento(evento);
  const handleBackToList = () => {
    setSelectedEvento(null);
    reloadEventi();
  };

  const reloadEventi = async () => {
    if (!selectedAziendaId) return;
    try {
      const response = await api.listEventi(selectedAziendaId, currentPage);
      setEventi(response.data.eventi);
      setPageCount(response.data.paginaEventi);
    } catch {
      toast.error('Errore durante il recupero degli eventi');
    }
  };

  if (selectedEvento) {
    return (
      <ModificaEvento
        idEvento={selectedEvento.id}
        evento={selectedEvento}
        onBack={handleBackToList}
      />
    );
  }

  const handleToggleActive = async (eventoId, isActive) => {
    try {
      await api.toggleEventoStatus(eventoId);
      await reloadEventi();
      toast.success(`Evento ${!isActive ? 'attivato' : 'disattivato'} con successo`);
    } catch (error) {
      toast.error(error.response?.data || 'Errore durante la modifica dello stato');
    }
  };

  const handleDeleteEvento = async (eventoId) => {
    const confirmDelete = window.confirm('Sei sicuro di voler cancellare questo evento?');
    if (!confirmDelete) return;
    try {
      await api.deleteEvento(eventoId);
      setEventi((prev) => prev.filter((e) => e.id !== eventoId));
      toast.success('Evento cancellato con successo');
    } catch (error) {
      toast.error(error.response?.data || 'Errore durante la cancellazione');
    }
  };

  return (
    <div>
      <h2>Lista offerte</h2>
      {loading && <p>Caricamento...</p>}
      {!loading && eventi.length === 0 && <p>Nessun evento trovato.</p>}
      {eventi.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Titolo</th>
              <th>Tipologia</th>
              <th>Data</th>
              <th>Prezzo</th>
              <th>Attivo</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {eventi.map((evento) => (
              <tr key={evento.id}>
                <td>{evento.titolo}</td>
                <td>
                  {evento.categorie && evento.categorie.length > 0
                    ? evento.categorie[0].nome
                    : 'N/A'}
                </td>
                <td>
                  {evento.dataInizio} - {evento.dataFine}
                </td>
                <td>{evento.prezzo}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={evento.active}
                    onChange={() => handleToggleActive(evento.id, evento.active)}
                    aria-label={`Attiva/disattiva ${evento.titolo}`}
                  />
                </td>
                <td>
                  <button onClick={() => handleSelectEvento(evento)}>Dettaglio</button>{' '}
                  <button onClick={() => handleDeleteEvento(evento.id)}>Cancella</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <ReactPaginate
        previousLabel={'Precedente'}
        nextLabel={'Successivo'}
        breakLabel={'...'}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={'pagination'}
        activeClassName={'active'}
      />
      <ToastContainer />
    </div>
  );
};

export default EventList;
